import { Money, toMoney } from '@betterment/js-runtime';
import { withScalars } from 'apollo-link-scalars';
import { parseISO } from 'date-fns';
import { IntrospectionQuery, buildClientSchema } from 'graphql';

import { data as schemaData } from '../../../graphql/schema.json';

export const scalarsLink = withScalars({
  schema: buildClientSchema(schemaData as unknown as IntrospectionQuery),
  typesMap: {
    HTML: {
      serialize: (parsed: unknown) => parsed,
      parseValue: (raw: unknown): DocumentFragment | null => {
        if (raw === null) return null;

        if (typeof raw === 'string') {
          const template = document.createElement('template');
          // See docs/rfc/safe-html-rendering-client-side.md for
          // an explanation of why this is safe
          /* eslint-disable security/no-inner-html */
          // nosemgrep: javascript.browser.security.insecure-document-method, javascript.browser.security.insecure-innerhtml
          template.innerHTML = raw;
          /* eslint-enable security/no-inner-html */

          return template.content;
        }

        throw new Error('parseValue Html expected a string');
      },
    },
    Cents: {
      serialize: (parsed: unknown): number | null => {
        if (parsed === null) return null;
        if ((parsed as Money).cents) return (parsed as Money).cents;
        throw new Error('Serialize Cents expected to serialize a Money');
      },
      parseValue: (raw: unknown): Money | null => {
        if (raw === null) return null;
        if (typeof raw === 'number') return toMoney(raw);
        throw new Error('parseValue Cents expected to parse a number');
      },
    },
    Date: {
      serialize: (parsed: unknown) => parsed,
      parseValue: (raw: unknown): Date | null => {
        if (raw === null) return null;
        if (typeof raw === 'string') return parseISO(raw);
        throw new Error('parseValue Date expected to parse an ISO8601 Date string');
      },
    },
  },
});
